import { useEffect, useRef } from 'react'

export const useScrollToBottom = () => {
  const scrollToBottom = () => {
    scrollToRef.current?.scrollIntoView({ behavior: 'smooth' })
  }
  const scrollToRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    scrollToBottom()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollToRef.current])

  return { scrollToRef }
}
